//layout
import LayoutFront from "layout/LayoutFront/LayoutFront";
import LayoutBack from "layout/LayoutBack/LayoutBack";
import { PageNotFound } from "components/NotFound/PageNotFound";

//FrontEnd
import Home from "../view/FrontEnd/Home/Home";
import SuggestionForm from "../view/FrontEnd/SuggestionForm/SuggestionForm";
import VOCForm from "../view/FrontEnd/VOCForm/VOCForm";
import MyListVOC from "../view/FrontEnd/MyVOC/MyListVOC";
import HomeVOCForm from "../view/FrontEnd/MyVOC/Form/HomeVOCForm";
import HomeProductService from "../view/FrontEnd/MyVOC/Form/HomeProductService";
import HomeSuggestion from "../view/FrontEnd/MyVOC/Form/HomeSuggestion";
import PublicFAQ from "../view/FrontEnd/PublicFAQ/PublicFAQ";
import Product from "../view/FrontEnd/PublicProductService/Product";
import Service from "../view/FrontEnd/PublicProductService/Service";
import Training from "../view/FrontEnd/PublicProductService/Training";
import DetailTraining from "../view/FrontEnd/PublicProductService/DetailTraining";
import FormPublicProductService from "../view/FrontEnd/PublicProductService/FormPublicProductService";
import LiveChatVOC from "../view/FrontEnd/Chat/ChatFront";
import Profile from "../view/FrontEnd/Profile/Profile";
import { SignalRNotify } from "../view/SignalRNotify";
import UserVerify from "view/FrontEnd/Verify/UserVerify";
import GBURQ from "view/FrontEnd/GBURQ/GBURQ";
import LayoutDefault from "layout/LayoutFront/LayoutDefault";
import GBURQForm from "view/FrontEnd/GBURQ/GBURQForm";

//BackEnd
import HomeBackEnd from "view/BackEnd/Home/HomeBackEnd";
import PageClassifyIssue from "view/BackEnd/CreateVOC/ClassifyVOCIssue/PageClassifyIssue";
import PageComplaint from "view/BackEnd/CreateVOC/Complaint/PageComplaint";
import ReferPageComplaint from "view/BackEnd/CreateVOC/Complaint/ReferPageComplaint";
import ReferPageRequest from "view/BackEnd/CreateVOC/Request/ReferPageRequest";
import PageRequest from "view/BackEnd/CreateVOC/Request/PageRequest";
import PageSuggest from "view/BackEnd/CreateVOC/Suggest/PageSuggest";
import PageProductAndService from "view/BackEnd/CreateVOC/ProductAndService/PageProductAndService";
import MyCreateVOCList from "view/BackEnd/CreateVOC/MyCreateVOC_List";
import ReferDetailVOC from "view/BackEnd/CreateVOC/ReferDetailVOC";
import VOCFormTrackingList from "view/BackEnd/VOCFormTracking/VOCFormTrackingList";
import LiveChat from "view/BackEnd/LiveChat/LiveChat";
import SatisFactionReport from "view/BackEnd/ReportVOC/SatisFaction/SatisFactionReport";
import SummaryStatusRequestReport from "view/BackEnd/ReportVOC/SummaryStatusRequest/SummaryStatusRequestReport";
import StatisticsVOCReport from "view/BackEnd/ReportVOC/StatisticsVOC/StatisticsVOCReport";
import InfoUVoiceReport from "view/BackEnd/ReportVOC/InfoUVoice/InfoUVoiceReport";
import InfoVOCFourSystemReport from "view/BackEnd/ReportVOC/InfoVOCFourSystem/InfoVOCFourSystemReport";
import ActivateForm from "view/BackEnd/ActivateUser/ActivateForm";
import ActivateList from "view/BackEnd/ActivateUser/ActivateList";

//Admin
import CustomerList from "view/BackEnd/Administrator/Customer/CustomerList";
import CustomerForm from "view/BackEnd/Administrator/Customer/CustomerForm";
import UserPermissionList from "view/BackEnd/Administrator/UserPermission/UserPermissionList";
import UserPermissionForm from "view/BackEnd/Administrator/UserPermission/UserPermissionForm";
import SLAManage from "view/BackEnd/Administrator/SLAManage/SLAManage";
import ImportInfo from "view/BackEnd/Administrator/ImportInfo/ImportInfo";
import MigrationDataUser from "view/BackEnd/MigrationData/MigrationDataUser";

const route = [
    {
        exact: true,
        path: "*",
        component: PageNotFound,
    },
    {
        exact: true,
        path: "/",
        component: Home,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        path: "/Home",
        component: Home,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        path: "/reqproduct",
        component: GBURQ,
        layout: LayoutDefault
    },
    {
        exact: true,
        path: "/reqservice",
        component: GBURQ,
        layout: LayoutDefault
    },
    {
        exact: true,
        path: "/reqtraining",
        component: GBURQ,
        layout: LayoutDefault
    },
    {
        exact: true,
        path: "/uvoiceform",
        component: GBURQForm,
        layout: LayoutDefault
    },
    //FrontEnd
    {
        exact: true,
        path: "/Front/Home",
        component: SuggestionForm,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        // path: "/Front/Product/:sID",
        path: "/Front/Product",
        component: Product,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        // path: "/Front/Service/:sID",
        path: "/Front/Service",
        component: Service,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        path: "/Front/Training",
        component: Training,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        path: "/Front/DetailTraining",
        component: DetailTraining,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        // path: "/Front/Training/:sID",
        path: "/Front/Training",
        component: Training,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },

    {
        exact: true,
        // path: "/Front/PublicProductAndServiceForm/:sID",
        path: "/Front/PublicProductAndServiceForm",
        component: FormPublicProductService,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        path: "/Front/FAQ",
        component: PublicFAQ,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        path: "/Front/MyVOC/HomeVOCForm",
        component: HomeVOCForm,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        path: "/Front/MyVOC/HomeProductService",
        component: HomeProductService,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        path: "/Front/MyVOC/HomeSuggestion",
        component: HomeSuggestion,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        path: "/Front/MyVOC",
        component: MyListVOC,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        path: "/Front/SuggestionForm",
        component: SuggestionForm,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        path: "/Front/VOCForm",
        component: VOCForm,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        path: "/Front/MyVOC/LiveChatVOC",
        component: LiveChatVOC,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        path: "/SignalRNotify",
        component: SignalRNotify,
        // layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    {
        exact: true,
        path: "/Front/Profile",
        component: Profile,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    // User Verify
    {
        exact: true,
        path: "/User/Verify",
        component: UserVerify,
        layout: LayoutFront,
        propLayout: {
            showPageDown: true,
            showPageUp: true,
        }
    },
    //BackEnd
    {
        exact: true,
        path: "/Backend/HomeBackEnd",
        component: HomeBackEnd,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/HomeBackEnd/PageClassifyIssue",
        component: PageClassifyIssue,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/HomeBackEnd/PageComplaint",
        component: PageComplaint,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/HomeBackEnd/PageRequest",
        component: PageRequest,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/HomeBackEnd/PageProductAndService",
        component: PageProductAndService,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/HomeBackEnd/PageSuggest",
        component: PageSuggest,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/MyCreateVOCList",
        component: MyCreateVOCList,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/MyCreateVOCList/PageComplaint",
        component: PageComplaint,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/MyCreateVOCList/PageComplaint/Refer",
        component: ReferPageComplaint,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/MyCreateVOCList/DetailVOC/:sID",
        component: ReferDetailVOC,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/MyCreateVOCList/PageRequest",
        component: PageRequest,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/MyCreateVOCList/PageRequest/Refer",
        component: ReferPageRequest,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/MyCreateVOCList/PageSuggest",
        component: PageSuggest,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/MyCreateVOCList/PageProductAndService",
        component: PageProductAndService,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/PageClassifyIssue",
        component: PageClassifyIssue,
        layout: LayoutBack,
    },

    {
        exact: true,
        path: "/Backend/PageProductAndService",
        component: PageProductAndService,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/PageComplaint",
        component: PageComplaint,
        layout: LayoutBack,
    },

    {
        exact: true,
        path: "/Backend/PageRequest",
        component: PageRequest,
        layout: LayoutBack,
    },

    {
        exact: true,
        path: "/Backend/PageSuggest",
        component: PageSuggest,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/VOCFormTrackingList",
        component: VOCFormTrackingList,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/VOCFormTrackingList/PageClassifyIssue",
        component: PageClassifyIssue,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/VOCFormTrackingList/PageComplaint",
        component: PageComplaint,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/VOCFormTrackingList/PageRequest",
        component: PageRequest,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/VOCFormTrackingList/PageSuggest",
        component: PageSuggest,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/VOCFormTrackingList/PageProductAndService",
        component: PageProductAndService,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/LiveChat",
        component: LiveChat,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/Report/SatisFactionReport",
        component: SatisFactionReport,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/Report/SummaryStatusRequestReport",
        component: SummaryStatusRequestReport,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/Report/StatisticsVOCReport",
        component: StatisticsVOCReport,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/Report/InfoUVoiceReport",
        component: InfoUVoiceReport,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/Report/InfoVOCFourSystemReport",
        component: InfoVOCFourSystemReport,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/Admin/CustomerList",
        component: CustomerList,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/Admin/CustomerForm",
        component: CustomerForm,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/Admin/Activate",
        component: ActivateList,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/Admin/ActivateForm",
        component: ActivateForm,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/Admin/UserPermissionList",
        component: UserPermissionList,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/Admin/UserPermissionForm",
        component: UserPermissionForm,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/Admin/SLAManage",
        component: SLAManage,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/Admin/ImportInfo",
        component: ImportInfo,
        layout: LayoutBack,
    },
    {
        exact: true,
        path: "/Backend/MigrationDataUser",
        component: MigrationDataUser,
        layout: LayoutBack,
    },
];

export default route;